import { createFileRoute } from "@tanstack/react-router";
import { PartnerApplicationForm } from "@/components/partner-application-form";
import { useTranslation } from "@/i18n";
import { socialImageMeta, breadcrumbLd } from "@/lib/seo";

const TITLE = "Become a Partner | BidNova Auctions";
const DESCRIPTION = "Apply to become a BidNova Official Partner, Featured Shop or homepage sponsor. Grow your trading card business with the UK's premium auction marketplace.";
const URL = "https://bidnovaauctions.uk/partners/apply";

export const Route = createFileRoute("/partners/apply")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      ...socialImageMeta(),
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [breadcrumbLd([{ name: "Home", path: "/" }, { name: "Partners", path: "/partners" }, { name: "Apply", path: "/partners/apply" }])],
  }),
  component: PartnersApplyPage,
});

function PartnersApplyPage() {
  const { t } = useTranslation("community");
  return (
    <PartnerApplicationForm
      defaultType="featured_shop"
      intro={
        <div className="mb-8 text-center">
          <p className="text-[11px] uppercase tracking-[0.2em] text-gold">{t("partners.apply.eyebrow", "Become a Partner")}</p>
          <h1 className="mt-2 font-display text-4xl text-white sm:text-5xl">{t("partners.apply.title", "Grow your business with BidNova")}</h1>
          <p className="mx-auto mt-4 max-w-xl text-muted-foreground">
            {t("partners.apply.subtitle", "Official Partners, Featured Shops, grading companies and accessories brands — apply to join the BidNova ecosystem. All placements are currently free and curated by our team.")}
          </p>
        </div>
      }
    />
  );
}
